import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useSpaceViewsOptionsPersistenceQuery from './__generated__/useSpaceViewsOptionsPersistenceQuery.graphql.ts';
import useSpaceViewsDataSpaceRootQuery from './__generated__/useSpaceViewsDataSpaceRootQuery.graphql.ts';

export function preloadSpaceViews(spaceKey: string, isLicensed: boolean) {
	const queries: Promise<any>[] = [];
	queries.push(
		query({
			query: useSpaceViewsDataSpaceRootQuery,
			variables: {
				spaceKey,
			},
		}),
	);

	if (isLicensed) {
		queries.push(
			query({
				query: useSpaceViewsOptionsPersistenceQuery,
				variables: {
					spaceKey,
				},
			}),
		);
	}
	return waitForAllReturnWhenError(queries);
}
